export default "__VITE_ASSET__CkHUSQMh__"